import { CustomerNegativeAccountHistoryMinDc } from "./customer-negative-account-history-min-dc.model";
import { SelectedAccount } from "../contact/selected-account.model";
import { AccountSelection } from "../contact/account-selection-dc.model";

export class RaiseDisputeDc {
    CustomerNegativeAccountHistoryMinDcs: Array<CustomerNegativeAccountHistoryMinDc>
    // CustomerNegativeAccountHistoryMinDc:CustomerNegativeAccountHistoryMinDc

    SelectedAccountsTransUnion: Array<SelectedAccount> = [];
    SelectedAccountsExperion: Array<SelectedAccount> = [];
    SelectedAccountsEquifax: Array<SelectedAccount> = [];
    SelectedAccountsCreditors: Array<SelectedAccount> = [];
    SelectedAccountsOtherBureau: Array<SelectedAccount> = [];

    transUnionAccounts: Array<AccountSelection> = [];
    experionAccounts: Array<AccountSelection> = [];
    equifaxAccounts: Array<AccountSelection> = [];
    creditorsAccounts: Array<AccountSelection> = [];
    otherBureauAccounts: Array<AccountSelection> = [];

    accIssueIdTransUnion: number;
    accIssueIdExperion: number;
    accIssueIdEquifax: number;
    accIssueIdCreditors: number;
    accIssueIdOtherBureau: number;
    
    disputeResultIdTransUnion: number;
    disputeResultIdExperion: number;
    disputeResultIdEquifax:number;
    disputeResultIdCreditors:number;
    disputeResultIdOtherBureau:number;
    // new propery with correct spelling
    experianAccounts: Array<AccountSelection> = [];
    SelectedAccountsExperian:  Array<SelectedAccount> = [];
    
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/crm/models/htmldata/raise-dispute-dc.model.ts